import { Box, Modal, CircularProgress } from "@mui/material";

const LoadingModal = ({ isOpen }) => {
  return (
    <Modal disableEscapeKeyDown open={isOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          backgroundColor: "#B2AC6D",
          borderColor: "grey.900",
          borderWidth: "3px",
          textAlign: "center",
          p: 3,
        }}
      >
        <h3>
          One moment while we save <br /> your activity...
        </h3>
        <CircularProgress />
      </Box>
    </Modal>
  );
};

export default LoadingModal;
